import styled from 'styled-components';

export const StyledMessage = styled.div`
  p {
    margin: 0;
    font-size: 0.906rem;
    line-height: 1.65;
    white-space: pre-wrap;
    text-wrap-style: pretty;
  }
`;
